
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

Vue.use(Gettext);

window._ = require('lodash');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import category from './components/Category.vue';
import product from './components/Product.vue';
import basketWindow from './components/Basket/BasketWindow.vue';
import basketResume from './components/Basket/BasketResume.vue';
import basketDelivery from './components/Basket/BasketDelivery.vue';

window.eventHub = new Vue();

window.vueApp = new Vue({
    el: '#app',

    components: {
        category,
        product,
        basketWindow,
        basketResume,
        basketDelivery,
    },

    data : {
        basepath : window.Laravel.requests.basepath,
        client : window.Laravel.data.client,

        /*
         * Search engine
         */
        query : $('#custom-search-input').val(),
        categories : window.Laravel.data.categories,
        bufferQuery : null,
        reset : false,
        searching : false,
        loading : false,

        bag : window.Laravel.data.bag,
        basket : window.Laravel.data.basket,
        opening_hours : window.Laravel.data.opening_hours,

        message : {
            type : null,
            title : null,
            action : null,
            data : null,
            windowClass : null,
        }
    },

    watch: {
        bufferQuery: _.debounce(function (value) {
            value = value.replace(/\/|\\|\<|\>|\?|\:|\_|\-|\+|\!|\*|\%|\'|\"|\=/g, '');

            this.query = value.trim(' ');
        }, window.isMobileDevice ? 1000 : 300),
        message : {
            deep: true,
            handler(data){
                $('body')[data.type ? 'addClass' : 'removeClass']('canScroll');
            },
        },
    },

    mounted(){
        $('.animated').addClass('loaded');

        //Close error message
        $(document).keydown(function(e) {
            // ESCAPE key pressed
            if (e.keyCode == 27) {
                this.resetMessage();
            }
        }.bind(this));

        //Show alert message from session
        this.checkForMessage();
    },

    computed: {
        getDefaultTimetable(){
            for ( var key in this.opening_hours )
                if ( this.opening_hours[key].default == true )
                    return this.opening_hours[key];

            return [];
        },
        getOpeningHours(){
            for ( var key in this.categories )
                if (
                    this.categories[key].opening_hours_id == this.getDefaultTimetable.id &&
                    this.categories[key].getOpeningHours
                )
                    return this.categories[key].getOpeningHours;

            return [];
        },
    },

    methods: {
        updateQuery(){
            this.query = this.bufferQuery;

            if ( this.isMobile() )
            {
                $('.searchbar button.btn-default').click().focus().blur();
                $(document).focus().blur().click();
                $(window).focus().blur().click();
            }
        },
        update(e){
            this.bufferQuery = e.target.value;
        },
        search(){
            this.$children[0].searching = true;
        },
        setMessage(title, type, action, data, callback, otherdata, windowClass){
            if ( !type )
                type = 'error';

            this.message.type = type;
            this.message.title = title;
            this.message.action = action;
            this.message.data = data;
            this.message.otherdata = otherdata;
            this.message.callback = callback;
            this.message.windowClass = windowClass;
        },
        resetMessage(){
            if ( this.message.callback )
                this.message.callback.call();

            this.message.type = null;
            this.message.title = null;
            this.message.action = null;
            this.message.data = null;
            this.message.callback = null;
            this.message.windowClass = null;

            this.bounceErrorInputs();
        },
        bounceErrorInputs(){
            $('form').each(function(){
                var errors = $(this).find('input.error, select.error, textarea.error, div.checkbox-inline.error');

                if ( errors.length > 0 ){
                    $('html, body').animate({
                        scrollTop: errors.first().offset().top - 100,
                    }, 500, function(){
                        errors.each(function(){
                            $(this).add($(this).parent().find('span.error')).addClass('bounceIn animated');

                            setTimeout(function(){
                                $(this).removeClass('bounceIn animated');
                            }.bind(this), 1500);
                        });
                    });

                    return false;
                }
            });
        },
        addToBasket(product){
            if ( $.isNumeric(product) )
                product = $('div.item[data-product-id="'+product+'"]').attr('data-data');

            this.$root.setMessage('Vyberte prosím variantu produktu.', 'empty', 'add-to-basket', product);
        },
        isMobile(){
            return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4)))
        },
        checkForMessage(){
            var message_success = window.Laravel.data.message_success,
                message_error = window.Laravel.data.message_error;

            if ( message_success )
                this.setMessage(message_success, 'success');

            if ( message_error )
                this.setMessage(message_error, 'error');
        },
        withoutBag(){
            //If is bag in basket
            for ( var key in this.basket )
            {
                if ( this.basket[key].product.id == this.bag.id )
                {
                    $.get(window.Laravel.requests.basket.delete, { item_id : key }, function(response){
                        window.location.href = window.Laravel.requests.basket.billingInformaiton;
                    }.bind(this));
                    return;
                }
            }

            window.location.href = window.Laravel.requests.basket.billingInformaiton;
        },
        addBag(){
            //If is bag in basket
            for ( var key in this.basket )
            {
                if ( this.basket[key].product.id == this.bag.id )
                {
                    window.location.href = window.Laravel.requests.basket.billingInformaiton;
                    return;
                }
            }

            //Save product into basket in session
            $.post(window.Laravel.requests.basket.store, { product_id : this.bag.id, quantity : 1, variants : null }, function(response){
                window.location.href = window.Laravel.requests.basket.billingInformaiton;
            }.bind(this));
        },
        getWeekDay(week_day){
            if ( !week_day && week_day !== 0 )
                week_day = new Date().getDay();

            if ( week_day === 8 )
                return 1;

            return week_day == 0 ? 7 : week_day;
        },
        getTodayTimes(week_day){
            var week_day = this.getWeekDay(week_day);

            for ( var key in this.getDefaultTimetable.times )
            {
                if ( parseInt(this.getDefaultTimetable.times[key].day) == week_day )
                {
                    return this.getDefaultTimetable.times[key];
                }
            }
        },
        getDateTime(item){
            var d = new Date();
                d.setHours(item[0]);
                d.setMinutes(item[1]);
                d.setSeconds(0);
            return d;
        },
        isClosedToday(times, timetable){
            if ( times.opened === false )
                return true;

            //If is this date in calendar eshop off
            if (times.day == this.getWeekDay() && this.isClosedDate((new Date()).toISOString().substring(0, 10), timetable))
                return true;

            return false;
        },
        isClosedDate(date, timetable){
            var data = (timetable||this.getDefaultTimetable).closed;

            data = typeof data == 'string' ? JSON.parse(data) : data;

            return data.indexOf(date) > -1
        },
        getTodayStatus(week_day){
            var times = this.getTodayTimes(week_day),
                now = new Date();
                now.setSeconds(0);

            var from = times.from.split(':'),
                to = times.to.split(':');

            var from_date = this.getDateTime(from),
                to_date = this.getDateTime(to);

            if ( now < from_date && week_day == null )
            {
                week_day = now.getDay() - 1;

                //If is today sunday, we turn it to saturday
                if ( week_day == -1 )
                    week_day = 6;

                return this.getTodayStatus(week_day);
            }

            //If closing time is lower then opening, set closing to next day
            if ( to_date <= from_date )
                to_date.setDate( to_date.getDate() + 1 );

            if ( week_day != null )
            {
                from_date.setDate( from_date.getDate() - 1 );
                to_date.setDate( to_date.getDate() - 1 );
            }

            //If is opened
            if ( now >= from_date && now <= to_date && ! this.isClosedToday(times) )
                return [true, 'Otvorené do ' + times.to];

            //Show next day opening hours
            if ( times.day != this.getWeekDay() || this.isClosedToday(times) )
                times = this.getTodayTimes(parseInt(times.day) + 1);

            return [false, 'Otvárame o ' + times.from];
        },
    },
});